// extracted by mini-css-extract-plugin
export var image = "kd_dr";